module.exports = __webpack_public_path__ + "static/media/Telefon.256ef43e.png";